import React from 'react'

import influencerData from '../../data-influencer/andrea'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const Andrea = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default Andrea
